// extracted by mini-css-extract-plugin
export default {"container":"kids_container__c8WQ9","title":"kids_title__D0nVE"};